<div class="pb-5">
  <div class="text-center mb-5">
    <p class="text-muted text-uppercase" i18n="@@logout.logged-out">Logged out</p>
    <h2 i18n="@@logout.logout-greatings">Come back soon!</h2>
  </div>
  <div class="d-flex flex-column align-items-center text-center">
    <a class="btn btn-primary w-fit-content text-uppercase px-5 py-3 mb-2" routerLink="/login" i18n="@@logout.log-back-in">Log back in</a>
    <a class="btn btn-link f-12 text-decoration-none" href="{{homepageUrl}}" i18n="@@logout.homepage">Homepage</a>
  </div>
</div>